import { api } from "../lib/api";


export const getSavMachineInfo = (
  token
) =>
  api
    .get(
      `/public/sav/${encodeURIComponent(
        token
      )}`
    )
    .then((response) => response.data);


export const submitSavTicket = (
  token,
  payload
) => {
  const formData = new FormData();

  Object.entries(payload || {}).forEach(
    ([key, value]) => {
      if (key === "attachments") {
        Array.from(value || []).forEach(
          (file) => {
            formData.append(
              "attachments",
              file
            );
          }
        );
        return;
      }

      formData.append(
        key,
        value ?? ""
      );
    }
  );

  return api
    .post(
      `/public/sav/${encodeURIComponent(
        token
      )}`,
      formData
    )
    .then((response) => response.data);
};
